import React from 'react';
import { TUserForm } from './index';
import { Input } from '@insly/qmt-reactjs-ui-lib';
import { ContactsItem, ContactPersonRow, ContactsDataBlockText } from 'styles/common';
import { translate } from 'utils';
import SearchInput from 'app/Components/BrokerSearch';

export const renderUsersForm = (
  form: TUserForm,
  handleChange: (key: string, value: string) => void,
  isProfileForm?: boolean,
  brokerName?: string
) => (
  <ContactsItem>
    <ContactPersonRow gridTemplate="1fr 1fr">
      <Input
        label={translate({ key: 'master.user.summary.user_name' })}
        name="name"
        value={form.name}
        handleChange={(key, value) => handleChange(key as string, value as string)}
      />
      <Input
        label={translate({ key: 'master.common.email' })}
        name="email"
        value={form.email}
        handleChange={(key, value) => handleChange(key as string, value as string)}
        disabled={isProfileForm}
      />
    </ContactPersonRow>
    <ContactPersonRow gridTemplate="1fr">
      {isProfileForm ? (
        <ContactsDataBlockText>Agencja: { brokerName }</ContactsDataBlockText>
      ) : (
        <>
          <SearchInput
            name="broker_id"
            label={translate({ key: 'master.broker.select' })}
            value={form.broker_id}
            handleChange={(key, value) => {
              handleChange(key, value);
            }}
            handleSubmit={(item) => {
              handleChange('broker_id', item.id);
            }}
            // validationErrors={validationErrors?.length ? getErrorsByFieldName('registrationNumber', validationErrors) : []}
            capitalized={true}
            validationErrors={[]}
          />
        </>

      )}
    </ContactPersonRow>
  </ContactsItem>
);
